import { styled, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { MiscSavio } from "../../configuration/themeSettings";


export const useScrollTopClasses = () => {
  const theme = useTheme();

  const classes = {
    root: {
      position: "sticky",
      bottom: "15px",
      marginLeft: "50%",
      marginRight: "50%",
      zIndex: 999,
    } as SxProps,

    buttonUp: {
      minWidth: 74, border: '1px solid ' + theme.palette.primary.main,
      '@media print': {
        visibility: "hidden",
      },
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        transform: "scale(1.2) !important",
        color: MiscSavio.hoverColor,
        borderColor: MiscSavio.hoverColor,
      },

    } as SxProps,

  };
  return classes;
}
